import React, { useEffect } from 'react'
import { Button, notification, Table } from 'antd'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'

import { fetchFooterList } from '~actions'
import { getCurrentUser } from '~context'
import { PageLayout } from '~stories'

const NOTIFICATION_MESSAGES = {
  UNAUTHORIZED: 'You are not authorized to perform this action.'
}

const PAGE_TITLE = 'Footer (MSG)'

const addNewFooterButton = isContentEditor => (
  <Route render={({ history }) => (
    <Button
      key='footer_add'
      onClick={() => {
        isContentEditor
          ? history.push('/footer/new')
          : notification.error({ message: NOTIFICATION_MESSAGES.UNAUTHORIZED })
      }}
      type='primary'
    >
      Add Footer
    </Button>
  )} />
)

const columns = [
  {
    title: 'Applications',
    dataIndex: 'app',
    key: 'app',
    render: (_, footer) => <a href={`/footer/${footer._id}/edit`}>{footer.app || 'MSG'}</a>
  }
]

const FooterList = ({ fetchFooterList, footers }) => {
  const { userDetails: { isContentEditor } } = getCurrentUser()

  useEffect(() => {
    fetchFooterList()
  }, [fetchFooterList])

  return (
    <PageLayout extra={[addNewFooterButton(isContentEditor)]} title={PAGE_TITLE}>
      <Table bordered columns={columns} dataSource={footers} pagination={false} rowKey='_id' />
    </PageLayout>
  )
}

FooterList.propTypes = {
  fetchFooterList: PropTypes.func,
  footers: PropTypes.array
}

FooterList.defaultProps = {
  footers: []
}

const mapStateToProps = state => {
  const { footers = [] } = state.footer
  return { footers }
}

const mapDispatchToProps = {
  fetchFooterList
}

export default React.memo(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(FooterList)
)
